import script from "./CarTarAlm.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarTarAlm.vue?vue&type=script&lang=ts&setup=true"

import "./CarTarAlm.vue?vue&type=style&index=0&id=276c2eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-276c2eda"]])

export default __exports__